var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.3,5.7099928 C18.1131685,5.52274013 17.8595176,5.4175072 17.595,5.4175072 C17.3304824,5.4175072 17.0768315,5.52274013 16.89,5.7099928 L12,10.5899928 L7.11,5.6999928 C6.92316847,5.51274013 6.66951764,5.4075072 6.405,5.4075072 C6.14048236,5.4075072 5.88683153,5.51274013 5.7,5.6999928 C5.31,6.0899928 5.31,6.7199928 5.7,7.1099928 L10.59,11.9999928 L5.7,16.8899928 C5.31,17.2799928 5.31,17.9099928 5.7,18.2999928 C6.09,18.6899928 6.72,18.6899928 7.11,18.2999928 L12,13.4099928 L16.89,18.2999928 C17.28,18.6899928 17.91,18.6899928 18.3,18.2999928 C18.69,17.9099928 18.69,17.2799928 18.3,16.8899928 L13.41,11.9999928 L18.3,7.1099928 C18.68,6.7299928 18.68,6.0899928 18.3,5.7099928 Z",
    id: "path-13456"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13456"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#path-13456"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4ee384163627c1c599b3c1561bf57eda.svg";
export { ForwardRef as ReactComponent };